var map = {
	"./Kentico.svg": 12755,
	"./Kontent.svg": 81012,
	"./Strapi.svg": 24147,
	"./about-skating-butler.svg": 93094,
	"./amazon.svg": 31787,
	"./atom.svg": 61710,
	"./backgrounds/background-line-arrow-head.svg": 20467,
	"./backgrounds/background-line.svg": 95935,
	"./backgrounds/cloud-dots-bottom.svg": 61673,
	"./backgrounds/cloud-dots-top.svg": 34222,
	"./backgrounds/cloud-page_header-dots-a.svg": 43202,
	"./backgrounds/cloud-page_header-dots-b.svg": 23295,
	"./backgrounds/cloud-page_proof-arrow.svg": 88231,
	"./backgrounds/cloud-page_proof-watermark.svg": 96263,
	"./backgrounds/concierge-form-bg-left-bottom.svg": 1110,
	"./backgrounds/concierge-form-bg-left-center.svg": 97815,
	"./backgrounds/concierge-form-bg-right-center.svg": 82367,
	"./backgrounds/concierge-page_header-a.svg": 81516,
	"./backgrounds/concierge-page_header-b.svg": 11848,
	"./backgrounds/concierge-page_header-c.svg": 84938,
	"./backgrounds/cta-block-hands-a.svg": 93606,
	"./backgrounds/cta-block-hands-b.svg": 87707,
	"./backgrounds/cta-block-hands-c.svg": 28115,
	"./backgrounds/home_dots.svg": 81150,
	"./ball-being-rolled.svg": 24642,
	"./bg-home.svg": 85943,
	"./checkmark.svg": 46801,
	"./color-blocks.svg": 3931,
	"./concierge-account-management.svg": 87691,
	"./concierge-audit.svg": 18079,
	"./concierge-review.svg": 43633,
	"./concierge-slack-channel.svg": 40055,
	"./concierge-ticket-prioritization.svg": 87695,
	"./concierge-training.svg": 64336,
	"./contentful.svg": 80678,
	"./contentstack.svg": 31758,
	"./datocms.svg": 21280,
	"./diagram/cdn-mini.svg": 96382,
	"./diagram/cdn-new.svg": 30881,
	"./diagram/cdn.svg": 61415,
	"./diagram/cli-big.svg": 99100,
	"./diagram/cli-mini.svg": 33644,
	"./diagram/cms-big.svg": 23862,
	"./diagram/cms-documents.svg": 95515,
	"./diagram/cms-mini.svg": 62121,
	"./diagram/cms.svg": 48734,
	"./diagram/code-documents.svg": 19125,
	"./diagram/content-creator.svg": 14145,
	"./diagram/database.svg": 2224,
	"./diagram/developer.svg": 88478,
	"./diagram/filesystem.svg": 96054,
	"./diagram/react.svg": 7046,
	"./diagram/user-new-small.svg": 31706,
	"./diagram/user-new.svg": 94900,
	"./diagram/user.svg": 35925,
	"./docs-keyvisual-conceptual-guides.svg": 29234,
	"./docs-keyvisual-homepage.svg": 32322,
	"./docs-keyvisual-how-to-guides.svg": 93695,
	"./docs-keyvisual-reference-guides.svg": 12430,
	"./docs-keyvisual-tutorials.svg": 85098,
	"./drupal.svg": 47291,
	"./gatsby-days-logo.svg": 26631,
	"./guides-astronaut-butler.svg": 48755,
	"./guides-markdown.svg": 52313,
	"./guides-react-hero-bottom.svg": 59752,
	"./guides-react.svg": 83891,
	"./guides-stars.svg": 94989,
	"./hand-dropping-ball.svg": 9755,
	"./hosting.svg": 25266,
	"./icon-apps.svg": 56718,
	"./icon-data.svg": 41861,
	"./icon-deployment.svg": 67641,
	"./icon-link.svg": 4690,
	"./icon-performance.svg": 14324,
	"./icons/article.svg": 29710,
	"./icons/gatsby-4-icon.svg": 88318,
	"./icons/md-arrow-forward.svg": 47479,
	"./jekyll.svg": 83357,
	"./light-purple-dot.svg": 74735,
	"./logo.svg": 45107,
	"./markdown.svg": 14515,
	"./monogram.svg": 36970,
	"./netlify-grayscale.svg": 67715,
	"./netlify.svg": 91796,
	"./nextjs.svg": 80873,
	"./ornaments/pricing-page-cta-stars.svg": 12716,
	"./ornaments/pricing-page-header-underline.svg": 43330,
	"./pictures/cloud-page_cms-previews-desktop.svg": 74966,
	"./pictures/cloud-page_cms-previews-mobile.svg": 96790,
	"./pictures/cloud-page_deploy-previews-desktop.svg": 17778,
	"./pictures/cloud-page_deploy-previews-mobile.svg": 50660,
	"./pictures/cloud-page_incremental-builds-desktop.svg": 71504,
	"./pictures/cloud-page_incremental-builds-mobile.svg": 76357,
	"./pictures/cloud-page_lighthouse-reports-desktop.svg": 51860,
	"./pictures/cloud-page_lighthouse-reports-mobile.svg": 77129,
	"./pictures/pricing-page-cta.svg": 4468,
	"./pictures/pricing-page_concierge.svg": 96423,
	"./pwa.svg": 58921,
	"./pwa_card.svg": 67083,
	"./react.svg": 86809,
	"./sanitize.svg": 17625,
	"./sanity.svg": 81534,
	"./silly-site-award.svg": 61508,
	"./silly-site-background.svg": 24425,
	"./silly-site-challenge-pattern-light.svg": 96149,
	"./silly-site-challenge-pattern.svg": 4129,
	"./silly-site-shapes.svg": 29913,
	"./silly-site-swag.svg": 13668,
	"./source.svg": 51723,
	"./support-cloud-knowledge-base.svg": 51296,
	"./support-form-background.svg": 79958,
	"./support-form-hand.svg": 72568,
	"./support-open-source-docs.svg": 5075,
	"./support-product-roadmap.svg": 49260,
	"./support-status-page.svg": 82590,
	"./use-case-ellipse-2.svg": 68511,
	"./use-case-ellipse.svg": 74191,
	"./use-case-polygon.svg": 33462,
	"./use-case-rectangle.svg": 36444,
	"./wordpress.svg": 6101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76547;